import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { Header, Typography, TypographyProps } from '../typography';

type SectionTitleProps = {
  variant?: Header;
  size?: 'extra';
} & Omit<TypographyProps, 'variant'>;

/**
 * Заголовок секции
 */
export const SectionTitle = ({
  children,
  className,
  color,
  as = 'h2',
  variant = 'h1',
  ...rest
}: SectionTitleProps) => (
  <Typography
    as={as}
    color={color}
    className={cn(className, styles)}
    variant={variant}
    {...(rest as SectionTitleProps)}>
    {children}
  </Typography>
);

SectionTitle.defaultProps = {
  variant: 'h1',
};

const styles = css`
  width: 100%;
  margin: 0 0 24px;

  @media (--only-largeDesktop) {
    margin: 0 0 32px;
  }
`;
